import {urls} from '@/constants/urls'
import {CarouselItem} from '@/types/overview'

export const getOverviewCarouselItems = (
    t: (key: string) => string,
    setIsModalVisible: (visible: boolean) => void
): CarouselItem[] => [
    {
        titleKey: 'Overview.cashAdvance',
        subtitleKey: 'Overview.expandYourBusiness',
        descriptionKey: 'Overview.needFastFunding',
        linkTextKey: 'Overview.learnMore',
        href: urls.cashAdvance,
        features: [t('Overview.upToAmount'), t('Overview.fixedFee'), t('Overview.fundsInTime')],
        backgroundColor: 'violet'
    },
    {
        titleKey: 'Overview.productGuides',
        subtitleKey: 'Overview.merchantPortal',
        descriptionKey: 'Overview.toHelpYouGetStarted',
        linkTextKey: 'Overview.merchantPortalGuide',
        href: urls.guides,
        backgroundColor: 'yellow'
    },
    {
        titleKey: 'Overview.whereToStart',
        subtitleKey: 'Overview.merchantPortal',
        descriptionKey: 'Overview.onlinePaymentSystem',
        linkTextKey: 'Overview.readMore',
        onLinkClick: () => setIsModalVisible(true),
        backgroundColor: 'blue'
    }
]

export const SHOW_CAROUSEL = true
